export class digitalCategoryDB {
    static digital_category = [
        {
            img: "<img src='assets/images/digital-product/graphic-design.png' class='imgTable'>",
            product_name: "Graphic Design",
            price: "$57.00",
            status: "<i class='fa fa-circle font-success f-12'></i>",
            category: "Digital",
        },
        {
            img: "<img src='assets/images/digital-product/ebooks.png' class='imgTable'>",
            product_name: "eBooks",
            price: "$472.00",
            status: "<i class='fa fa-circle font-warning f-12'></i>",
            category: "Digital",
        },
        {
            img: "<img src='assets/images/digital-product/lecture-video-recorder.jpg' class='imgTable'>",
            product_name: "Recorded lectures",
            price: "$54.00",
            status: "<i class='fa fa-circle font-success f-12'></i>",
            category: "Digital",
        },
        {
            img: "<img src='assets/images/digital-product/application.jpg' class='imgTable'>",
            product_name: "Application",
            price: "$578.00",
            status: "<i class='fa fa-circle font-danger f-12'></i>",
            category: "Digital",
        },
        {
            img: "<img src='assets/images/digital-product/web-dev.jpg' class='imgTable'>",
            product_name: "Websites",
            price: "$5764.00",
            status: "<i class='fa fa-circle font-warning f-12'></i>",
            category: "Digital",
        },
    ]
}
